import { cachedHttp } from "./httpService";

const apiEndPoint = "/segments/";

function getSegments() {
  return cachedHttp.get(apiEndPoint);
}

export default getSegments;
